module.exports = __webpack_public_path__ + "static/media/thor.e752f791.png";